'use strict';

angular
  .module('adminEmailTemplatesControllers')

  .controller('MainEmailTemplatesController', [
    '$scope',
    '$translate',
    'topBar',
    'authenticatedUser',
    function ($scope, $translate, topBar, authenticatedUser) {
      $translate('iam.admin.emailTemplates.pageTitle').then(function (translation) {
        topBar.setTitleAndIcon(translation, 'fa-envelope-o');
      });

      $scope.currentIdentity = authenticatedUser.IdentityName;
    },
  ]);
